import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
    "model-value": _ctx.isDownloadShow,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "show-close": true,
    onClose: _ctx.closeDialog,
    title: _ctx.data.title,
    width: "440px",
    center: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.clickCom('inner'))
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("下载国内导入模版")])),
      _: 1,
      __: [2]
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[1] || (_cache[1] = $event => _ctx.clickCom('out'))
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("下载国外导入模版")])),
      _: 1,
      __: [3]
    })]),
    _: 1
  }, 8, ["model-value", "onClose", "title"])]);
}